








import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { isPlatformWindows } from '@/utils/cordova'
import { ChartData } from 'chart.js'
import _ECGChart from './_ECGChart.vue'

@Component({
  components: {
    Chart: () => import('./_ECGChart.vue')
  }
})
export default class ECGChart extends Vue {
  @Prop({ required: false }) width?: number
  @Prop({ required: false }) height?: number
  @Prop({ required: false }) type?: string

  @Ref('chart') chart!: _ECGChart

  get _ecgData() {
    if (
      !this.$store.state.ecg.largeDataEnabled &&
      this.$store.state.ecg.type === 'saved'
    ) {
      return this.$store.state.ecg.savedData
    } else {
      return this.type === 'load'
        ? this.$store.state.ecg.loadData
        : this.$store.state.ecg.savedData
    }
  }

  ecgData = [] as { ecg: number; measurementDate: Date }[]

  get chartData(): ChartData {
    if (!this.ecgData) return {}
    let count = 0
    return {
      labels: this.ecgData.map(() => {
        count++
        return count - 1
      }),
      datasets: [
        {
          label: '心電図',
          data: this.ecgData.map(v => v.ecg),
          lineTension: 0.1,
          fill: false,
          borderColor: 'red',
          pointBorderColor: 'red',
          pointRadius: 0.1,
          borderWidth: 1,
          pointBorderWidth: 0.5
        }
      ]
    }
  }

  update() {
    if (
      this.type == 'saved' ||
      (!this.$store.state.ecg.largeDataEnabled &&
        this.$store.state.ecg.type === 'saved')
    ) {
      this.ecgData = this._ecgData
    } else {
      this.ecgData = this._ecgData
        .slice(this.$store.state.ecg.firstIdx)
        .concat(this._ecgData.slice(0, this.$store.state.ecg.firstIdx))
    }
  }
  created() {
    const update = () => {
      if (this.$store.state.ecg.type === 'load') {
        this.ecgData = this._ecgData
          .slice(this.$store.state.ecg.firstIdx)
          .concat(this._ecgData.slice(0, this.$store.state.ecg.firstIdx))
      }
    }

    if (this.type == 'load') {
      const id = setInterval(
        () => {
          update()
        },
        isPlatformWindows() ? 3000 : 1000
      )

      this.$on('hook:beforeDestroy', () => {
        clearInterval(id)
      })
    } else {
      this.ecgData = this._ecgData
    }
  }

  resize() {
    this.chart.$data._chart.resize()
  }
}
